import React, { Fragment, useState, useEffect } from "react";
import {
    Row, Col, Form, FormGroup, Button, Container, Card, CardBody
} from "reactstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { uploadBulkSample, getActiveCompany, getGeographicalCoverByCompanyId } from "../../../../api";
import axios from 'axios';

const BulkUploadSample = (props) => {
    const { register, handleSubmit, errors, setValue, trigger, getValues, reset } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [fileUrl, setFileUrl] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [geoCovers, setGeoCovers] = useState([]);
    const [selectedGeoCover, setSelectedGeoCover] = useState("");
    const [uploadedFileUrl, setUploadedFileUrl] = useState("");
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchCompanies = async () => {
        try {
            const res = await getActiveCompany();
            if (res.status === 200) {
                setCompanies(res.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
            toast.error("Failed to load companies");
        }
    };

    const handleCompanyChange = async (companyId) => {
        try {
            console.log("SelectedCompany===>", companyId);

            setSelectedGeoCover("");
            setGeoCovers([]);

            const companyRes = await getGeographicalCoverByCompanyId(companyId);

            console.log("companyRes =>", companyRes);

            if (companyRes?.status === 200) {
                const isDomestic = companyRes?.data?.result?.isDomestic;

                if (isDomestic) {
                    setGeoCovers([
                        {
                            label: "Domestic",
                            value: "Domestic",
                        },
                        {
                            label: "International",
                            value: "International",
                        },
                    ]);
                } else {
                    setGeoCovers([
                        {
                            label: "International",
                            value: "International",
                        },
                    ]);
                    setSelectedGeoCover("International");
                }
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch geographical cover");
        }
    };

    const handleFileUpload = (file) => {
        const formData = new FormData();
        formData.append("profile", file);

        axios
            .put(`${process.env.REACT_APP_SERVER_URL}/api/users/uploadImage`, formData)
            .then((res) => {
                console.log("Upload Response =>", res.data);

                setFileUrl(res.data?.msg); // uploaded file URL
                toast.success("File Uploaded Successfully");
            })
            .catch((err) => {
                console.error("Upload Error =>", err);
                toast.error("File Upload Failed");
            });
    };

    const submitBulkSample = async (data) => {
       
        if (!data.company_id) {
            toast.error("Please select a company.");
            return;
        }
        console.log("payload", data.company_id, selectedGeoCover, fileUrl);
        const formData = new FormData();

        formData.append("filePath", fileUrl);
        formData.append("company_id", data.company_id);
        formData.append("fileType", selectedGeoCover);

        setIsSubmitting(true);
        try {
            const res = await uploadBulkSample(formData);
            if (res.status === 200) {
                toast.success("Sample file uploaded successfully");
                setFileUrl(require("../../../../assets/images/file-upload.png"));
                reset();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to upload sample file");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Fragment>
            <Container fluid={true} style={{ padding: '20px', margin: '20px 0' }}>
                <Row>
                    <Col sm="12">
                        <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 8px 24px rgba(149, 157, 165, 0.2)' }}>
                            <CardBody style={{ padding: '30px' }}>
                                <div className="d-flex justify-content-between align-items-center" style={{ borderBottom: '1px solid #eaeaea', paddingBottom: '15px', marginBottom: '25px' }}>
                                    <h5 style={{ margin: 0, fontWeight: '600', color: '#2d3748', fontSize: '20px' }}>
                                        <i className="fa fa-cloud-upload" style={{ marginRight: '10px', color: '#3182ce' }}></i>
                                        Upload Bulk Sample File
                                    </h5>
                                </div>

                                <Form className="needs-validation" onSubmit={handleSubmit(submitBulkSample)}>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xl="5" md="5">
                                            <FormGroup>
                                                <label>Company</label>
                                                <select
                                                    className="form-control"
                                                    name="company_id"
                                                    ref={register({ required: true })}
                                                    onChange={(e) => handleCompanyChange(e.target.value)}
                                                >
                                                    <option value="">Select Company</option>
                                                    {companies.map((company) => (
                                                        <option
                                                            key={company.company_id}
                                                            value={company.company_id}
                                                        >
                                                            {company.client_company_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span style={{ color: "#e53e3e", fontSize: "13px", marginTop: "8px", display: "block", fontWeight: "500" }}>
                                                    {errors.company_id && "Company is required"}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {geoCovers.length > 0 && (
                                        <Row>
                                            <Col xl="5" md="5">
                                                <FormGroup>
                                                    <label>Geographical Cover</label>

                                                    {geoCovers.map((cover) => (
                                                        <div key={cover.value}>
                                                            <input
                                                                type="radio"
                                                                name="geo_cover"
                                                                value={cover.value}
                                                                checked={selectedGeoCover === cover.value}
                                                                onChange={(e) =>
                                                                    setSelectedGeoCover(e.target.value)
                                                                }
                                                            />
                                                            <span className="ml-2">
                                                                {cover.label}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xl="7" md="7">
                                            <div style={{ background: '#f7fafc', padding: '30px 20px', borderRadius: '10px', border: '2px dashed #cbd5e0', textAlign: 'center', cursor: 'pointer', position: 'relative', transition: 'all 0.2s ease-in-out' }}>
                                                <FormGroup style={{ margin: 0 }}>
                                                    <input
                                                        type="file"
                                                        accept=".xls,.xlsx"
                                                        onChange={(e) => handleFileUpload(e.target.files[0])}
                                                        style={{ opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                                    />
                                                    <div style={{ pointerEvents: 'none' }}>
                                                        <i className="fa fa-cloud-upload" style={{ fontSize: '36px', color: selectedFile ? '#3182ce' : '#a0aec0', marginBottom: '12px' }}></i>
                                                        <h6 style={{ color: selectedFile ? '#2d3748' : '#4a5568', margin: 0, fontWeight: '600', fontSize: '15px' }}>
                                                            {selectedFile ? selectedFile.name : "Click or drag file to this area to upload"}
                                                        </h6>
                                                        {!selectedFile && <p style={{ fontSize: '13px', color: '#718096', marginTop: '8px', marginBottom: 0 }}>Support for a single .xls or .xlsx file.</p>}
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xl="5" md="5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '20px', paddingLeft: '30px' }}>
                                            <Button
                                                color="primary"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{ width: '100%', borderRadius: '8px', padding: '14px', fontSize: '15px', fontWeight: '600', background: '#3182ce', border: 'none', boxShadow: '0 4px 6px rgba(49, 130, 206, 0.2)', transition: 'all 0.2s' }}
                                            >
                                                {isSubmitting ? (
                                                    <><i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i> Uploading...</>
                                                ) : (
                                                    <><i className="fa fa-upload" style={{ marginRight: '8px' }}></i> Upload Sample</>
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default BulkUploadSample;
